module.exports = __webpack_public_path__ + "static/media/call.d327f4ae.svg";